e360.controller('EditPreRegController',
   ['$scope', '$q', '$window', 'preregApi', 'eventsApi', 'surveyItemsApi', '$stateParams', 'utils', 'session', 'toast', 'loader', 'titleService', 'GuestTypeService',
      function ($scope, $q, $window, preregApi, eventsApi, surveyItemsApi, $stateParams, utils, session, toast, loader, titleService, guestTypeService) {
         var members = {};

         titleService.setTitle('Pre-registrant Management');
         $scope.prereg = { isConfirmed: true, country: 'US' };
         $scope.loader = loader;

         $scope.onPickPlace = function(place) {
            $scope.prereg.city = place.city;
            $scope.prereg.state = place.stateCode;
            $scope.prereg.country = place.countryCode;
         };

         members.initialize = function () {
            loader.hide();
            $scope.isInitializing = true;
            $scope.hasTimeSlots = session.getCampaign().hasTimeSlots;
            $scope.defaultLanguage = session.getCampaign().defaultLanguage;
            $scope.canAddGuest = false;

            guestTypeService.list(session.getCampaign().id).then(function(guestTypes) {
               $scope.guestTypes = guestTypes;
            });

            if ($scope.isEditMode()) {
               members.getPreReg($stateParams.id);
            } else if ($stateParams.eventId) {
               members.getEvent($stateParams.eventId);
               members.getHost().then(function(host) {
                  $scope.prereg.timeSlotId = host.timeSlot.id;
                  $scope.prereg.guestTypeId = host.guestTypeId;
               });
            } else {
               $scope.isInitializing = false;
            }
         };

         members.getHost = function() {
            var deferred = $q.defer();

            if ($stateParams.hostId) {
               preregApi.get($stateParams.hostId).then(function(data) {
                  return deferred.resolve(data);
               });
            } else {
               deferred.reject();
            }

            return deferred.promise;
         };

         members.getPreReg = function (id) {
            preregApi.get(id).then(function (data) {
               $scope.prereg = data;
               if (data.dateOfBirth) {
                  $scope.prereg.dateOfBirth = moment(data.dateOfBirth).format('MM/DD/YYYY');
               }
               $scope.canAddGuest = !data.isGuest;
               $scope.qrUrl = utils.getQRUrl({wbid: $scope.prereg.wristBandId});

               members.getEvent(data.event.id);

               return surveyItemsApi.list(session.getBrand().id);
            }).then(function (data) {
               // Reduce survey array to dict object
               $scope.surveyItems = _.reduce(data, function(map, obj) {
                  // Reduce choice array to dict object
                  obj.surveyItemChoices = _.reduce(obj.surveyItemChoices, function(m, o) {
                     m[o.key] = o;
                     return m;
                  }, {});

                  // Multi select is simpler using the choice keys since the choice is saved differently than the
                  // data model of the survey & choices themselves
                  if (obj.type == 'Multioption') {
                     obj.choices = [];
                     _.each(obj.surveyItemChoices, function(choice) {
                        obj.choices.push(choice.key);
                     });
                  }

                  map[obj.key] = obj;
                  return map;
               }, {});

               _.each($scope.prereg.surveyItems, function(survey) {
                  if ($scope.surveyItems[survey.name].type == 'Multioption') {
                     survey.choices = survey.value.split(',');
                  }
               });
            });
         };

         members.getEvent = function (eventId) {
            // get full "event details" for timeslots
            // event-selector in view will overwrite the selectedEvent
            eventsApi.get(eventId).then(function (event) {
               $scope.eventDetail = event;
               $scope.selectedEvent = event;
            }).finally(function () {
               $scope.isInitializing = false;
            });
         };

         $scope.eventsChanged = function (event) {
            $scope.isInitializing = true;
            members.getEvent(event.id);
         };

         $scope.isEditMode = function () {
            return $stateParams.id;
         };

         $scope.goBack = function () {
            $window.history.back();
         };

         $scope.save = function () {
            var invalidPhone = $('input.ng-invalid-international-phone-number');
            if (invalidPhone && invalidPhone.length > 0) {
               toast.error().message('Please enter a valid phone number').send();
               return;
            }

            $scope.$broadcast('phone.save.pre', true);

            var dto = angular.copy($scope.prereg);

            if ($scope.eventDetail) {
               dto.eventId = $scope.eventDetail.id;
            }

            if ($stateParams.hostId) {
               dto.hostId = $stateParams.hostId;
            }

            if (dto.dateOfBirth) {
               dto.dateOfBirth = utils.toServerDateTime(dto.dateOfBirth, "MM/DD/YYYY");
            }

            if (!dto.email) {
               dto.email = null;
            }

            _.each(dto.surveyItems, function(res) {
               if (res.choices) {
                  res.value = res.choices.join(',');
                  delete res.choices;
               }
            });

            var promise,
               message = (dto.hostId) ? 'Guest' : 'Pre-registration';

            loader.showSpinner();
            if ($scope.isEditMode()) {
               message += ' saved!';
               promise = preregApi.update(dto);
            } else {
               message += ' created!';
               promise = preregApi.create(dto);
            }

            promise.then(function (data) {
               $scope.goBack();
               toast.success()
                  .message(message)
                  .send();
            })['finally'](function () {
               loader.hide();
               $scope.$broadcast('phone.save.post', true);
            });
         };

         $scope.preventQRCodeLinkIfEmpty = function ($event) {
            if (!$scope.prereg.wristBandId) {
               $event.preventDefault();
            }
         };

         $scope.getTimeSlotLabel = function (timeSlot) {
            var label = '';
            if (timeSlot.name) {
               label += timeSlot.name + ' ';
            }
            label += utils.formatDate(timeSlot.startDateTime, 'M/D/YYYY - h:mma');
            return label;
         };

         members.initialize();

      }]);
